import React from "react";

export default () => {
	React.useEffect(() => {
		window.location.href = "/metal-solutions/industries/medical-health-safety";
	}, []);
	return <></>;
};
